import(/* webpackMode: "eager", webpackExports: ["default"] */ "/kingsyard-ssr/src/components/StudentDiscountPage/studentDiscountPage.js");
